import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import Navbar from './Navbar';
import { walletState } from '@/atom/wallet';
import { useRecoilState } from 'recoil';

const Layout = () => {
  const [wallet] = useRecoilState(walletState);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          flex: 1,
          paddingTop: { xs: '72px', md: '0px' },
        }}
      >
        {wallet ? <Navbar /> : ''}
        {/* {web3authCall?.connected() ? <Navbar /> : ''} */}

        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            height: '100vh',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default Layout;
